import React, { Component } from "react";
import { Spinner } from "reactstrap";
import swal from "sweetalert";
import BusImagesModal from "../../../../components/DashboardComponents/BusImagesModal";
import CustomModal from "../../../../components/WebsiteComponents/CustomModal";
import { axiosGet, axiosPost } from "../../../../utils/AxiosApi";
import { URL, moduleName } from "../../../../utils/Constants";
import {
  displayConfirmDeleteAlert,
  displayErrorAlert,
  DISPLAYMESSAGE,
} from "../../../../utils/DisplayMessage";
import {
  checkRolePermissions,
  getRolesFromStorage,
} from "../../../../utils/Helper";
import CreateBusSeatConfiguration from "./CreateBusSeatConfiguration";
import CreateBus from "./CreateBus";
import BusSeatUI from "../../../../components/DashboardComponents/BusSeatUI";
import Pagination from "react-js-pagination";

class Bus extends Component {
  state = {
    buses: [],
    busId: "",
    busTypes: [],
    createModal: false,
    createSeatModal: false,
    createSeatPermission: false,
    dataSpinner: false,
    deletePermission: false,
    edit: false,
    editPermission: false,
    imageModal: false,
    mediaData: [],
    seatConfigData: [],
    selectedData: "",
    viewModal: false,
    viewSeatPermission: false,
    current_page: 1,
    totalItemsCount: 0,
    paginated_value: 10,
  };

  componentDidMount() {
    this.getBuses();
    this.getBusTypes();
    this.permissions();
  }

  getBuses = (pageNumber, paginated_value) => {
    let page = pageNumber || this.state.current_page
    let paginatedValue = paginated_value || this.state.paginated_value
    let param = {
      page: page,
      paginated_value: paginatedValue,
    }
    this.setState({ dataSpinner: true, buses: [] }, function () {
      axiosPost(
        URL.buses + "/get-buses", param,
        (response) => {
          if (response.status === 200) {
            this.setState({
              buses: response.data.data.items,
              totalItemsCount: response.data.data.totalData,
              current_page: page,
              paginated_value: paginatedValue,
              dataSpinner: false,
            });
          }
        },
        (err) => {
          displayErrorAlert(err);
          this.setState({ dataSpinner: false });
        }
      );
    });
  };

  getBusTypes = (pageNumber, paginated_value) => {
    let param = {
    }
    axiosPost(
      URL.busTypes + "/get-bus-type", param,
      (response) => {
        if (response.status === 200) {
          this.setState({
            busTypes: response.data.data.items,
          });
        }
      },
      (err) => {
        displayErrorAlert(err);
      }
    );
  };

  handleCreateModal = () => {
    this.setState({ createModal: !this.state.createModal, edit: false });
  };

  handleCreateSeat = (item) => {
    if (item) {
      this.setState({ busId: item.id });
    }
    this.setState({
      createSeatModal: !this.state.createSeatModal,
      edit: false,
      seatConfigData: [],
    });
  };

  handleDelete = (params) => {
    this.setState({ loader: true }, () => {
      axiosGet(
        URL.deleteBus + "/" + params.id,
        (response) => {
          if (response.status === 200) {
            swal("Success", DISPLAYMESSAGE.deleteSuccess, "success");
            this.setState({
              loader: false,
            });
            this.getBuses();
          } else {
            swal("Error", response.message, "error");
          }
        },
        (error) => {
          displayErrorAlert(error);
        }
      );
    });
  };

  handleDeleteBtnClick = (id) => {
    let params = { id: id };
    displayConfirmDeleteAlert(params, this.handleDelete);
  };

  handleEdit = (item) => {
    this.setState({ selectedData: item, edit: true, createModal: true });
  };

  handleImageModal = (media) => {
    this.setState({ mediaData: media, imageModal: !this.state.imageModal });
  };

  handleViewSeat = (item) => {
    let id = item.id;
    if (!this.state.viewModal) {
      axiosGet(URL.getBusSeatConfiguration + "/" + id, async (response) => {
        if (response.status === 200) {
          let datum = await response.data.data.items[0].bus_rows;
          let newData = [];

          datum.forEach((el) => {
            let columns = [];
            let count = 0;
            el.bus_columns.forEach((cc) => {
              let columnName = "";
              if (cc.is_passage == 0) {
                // columnName = count + 1;
                // count++;
                columnName = cc.name;
              }
              columns.push({
                id: cc.id,
                columnName: columnName,
                is_driver: cc.is_driver == 1 ? true : false,
                is_open_for_booking: cc.is_open_for_booking == 1 ? true : false,
                is_empty: cc.is_passage == 1 ? true : false,
              });
            });
            newData.push({
              row: el.name,
              id: el.id,
              columns: columns,
            });
          });
          this.setState({
            seatConfigData: newData,
            viewModal: !this.state.viewModal,
          });
        }
      });
    } else {
      this.setState({ viewModal: !this.state.viewModal, seatConfigData: [] });
    }
  };

  permissions = () => {
    this.setState({
      editPermission: checkRolePermissions("update", moduleName.bus),
      viewSeatPermission: checkRolePermissions(
        "view",
        moduleName.busSeatConfiguration
      ),
      createSeatPermission: checkRolePermissions(
        "create",
        moduleName.busSeatConfiguration
      ),
      deletePermission: checkRolePermissions("delete", moduleName.bus),
    });
  };

  handleEditSeats = (item) => {
    axiosGet(URL.getBusSeatConfiguration + "/" + item.id, async (response) => {
      if (response.status === 200) {
        let datum = await response.data.data.items[0].bus_rows;
        let newData = [];

        datum.forEach((el) => {
          let columns = [];
          let count = 0;
          el.bus_columns.forEach((cc) => {
            let columnName = "";
            if (cc.is_passage == 0) {
              // columnName = count + 1;
              // count++;
              columnName = cc.name;
            }
            columns.push({
              id: cc.id,
              columnName: columnName,
              is_driver: cc.is_driver == 1 ? true : false,
              is_open_for_booking: cc.is_open_for_booking == 1 ? true : false,
              is_empty: cc.is_passage == 1 ? true : false,
            });
          });
          newData.push({
            row: el.name,
            id: el.id,
            columns: columns,
          });
        });
        this.setState({
          seatConfigData: newData,
          selectedData: item,
          // seatModal: !this.state.seatModal,
          edit: true,
          // viewModal: !this.state.viewModal,
          busId: item.id,
          createSeatModal: !this.state.createSeatModal,
        });
      }
    });
  };

  handlePaginatedValueChange = (value) => {
    let valuePage = parseInt(value);
    this.setState({ paginated_value: valuePage }, () => {
      this.getBuses(1, valuePage);
    });
  };

  render() {
    const { current_page, paginated_value, totalItemsCount } = this.state;

    const roles = getRolesFromStorage();
    return (
      <>
        <div className="dashboardHeader">
          <strong>BUSES</strong>
        </div>
        <div className="container-fluid h-100">
          <div className="row mt-2">
            <div className="col">
              {checkRolePermissions("create", moduleName.bus) ? (
                <button
                  className="btn btn-success"
                  onClick={this.handleCreateModal}
                >
                  Add Bus
                </button>
              ) : null}
            </div>
          </div>
          <div className="row mt-2 h-100">
            <div className="col d-flex align-items-center justify-content-between flex-column">
              <div className="table-responsive w-100">
                <table className="table table-striped text-center">
                  <thead>
                    <tr>
                      <th>S.N.</th>
                      <th>Name</th>
                      <th width="130px">Bus Type</th>
                      <th>Number Plate</th>
                      <th>Features</th>
                      <th>Images</th>
                      {this.state.viewSeatPermission ? (
                        <th>Bus Seats</th>
                      ) : null}
                      {this.state.editPermission ||
                        this.state.createSeatPermission ? (
                        <th width="180px">Options</th>
                      ) : null}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.buses?.length > 0 ? (
                      this.state.buses?.map((item, idx) => {
                        return (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>
                              {item.name}
                              <br />
                              {roles[0] === "Network Admin" && (
                                <span className="badge rounded-pill bg-info text-dark text-white">
                                  {item.travel_agency.name}
                                </span>
                              )}
                            </td>
                            <td>{item.bus_type.type}</td>
                            <td>{item.number_plate}</td>
                            <td>{item.feature}</td>
                            <td>
                              {item.media.length > 0 ? (
                                <button
                                  className="btn btn-secondary"
                                  onClick={() =>
                                    this.handleImageModal(item.media)
                                  }
                                >
                                  <i className="fa-solid fa-eye"></i>
                                </button>
                              ) : (
                                "No Images"
                              )}
                            </td>
                            {this.state.viewSeatPermission ? (
                              <td>
                                {item.has_seat_configuration ? (
                                  <>
                                    <button
                                      className="btn btn-secondary m-1"
                                      onClick={() => this.handleViewSeat(item)}
                                    >
                                      <i className="fa-solid fa-eye"></i>
                                    </button>{" "}
                                    <button
                                      className="btn btn-info m-1"
                                      onClick={() => this.handleEditSeats(item)}
                                    >
                                      <i className="fa-solid fa-pen-to-square"></i>
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <p>Not Configured</p>
                                    {this.state.createSeatPermission &&
                                      !item.has_seat_configuration ? (
                                      <button
                                        className="btn btn-primary me-3 mb-2"
                                        onClick={() =>
                                          this.handleCreateSeat(item)
                                        }
                                      >
                                        Configure
                                      </button>
                                    ) : null}
                                  </>
                                )}
                              </td>
                            ) : null}
                            {this.state.editPermission ||
                              this.state.createSeatPermission ? (
                              <td>
                                {this.state.editPermission ? (
                                  <button
                                    className="btn btn-primary me-2"
                                    onClick={() => this.handleEdit(item)}
                                  >
                                    <i className="fa-solid fa-pen-to-square"></i>
                                  </button>
                                ) : null}

                                {this.state.deletePermission ? (
                                  <button
                                    className="btn btn-danger ms-3"
                                    onClick={() =>
                                      this.handleDeleteBtnClick(item.id)
                                    }
                                  >
                                    <i className="fa-solid fa-trash"></i>
                                  </button>
                                ) : null}
                              </td>
                            ) : null}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan={
                            (this.state.editPermission ||
                              this.state.createSeatPermission) &&
                              this.state.viewSeatPermission
                              ? 8
                              : ((this.state.editPermission ||
                                this.state.createSeatPermission) &&
                                !this.state.viewSeatPermission) ||
                                ((!this.state.editPermission ||
                                  !this.state.createSeatPermission) &&
                                  this.state.viewSeatPermission)
                                ? 8
                                : 7
                          }
                          className="text-center p-3"
                        >
                          {this.state.dataSpinner ? (
                            <>
                              <Spinner color="primary"></Spinner>
                              <br />
                              Loading Data...
                            </>
                          ) : (
                            "No Bus found. Create one first"
                          )}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {this.state.buses.total <= 10 ? (
                <></>
              ) : (
                <div className="paginationContainer">
                  <Pagination
                    activePage={current_page}
                    itemsCountPerPage={paginated_value}
                    totalItemsCount={totalItemsCount}
                    onChange={(pageNumber) => this.getBuses(pageNumber, paginated_value)}
                    itemClass="page-item"
                    linkClass="page-link"
                    firstPageText="First"
                    lastPageText="Last"
                  />
                  <div className="paginatoion_paginated_value ml-3">
                    <select
                      className="form-control"
                      value={this.state.paginated_value}
                      onChange={(e) => this.handlePaginatedValueChange(e.target.value)}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={30}>30</option>
                      <option value={40}>40</option>
                      <option value={50}>50</option>
                    </select>
                  </ div>
                </div>
              )}
            </div>
          </div>
          <CustomModal
            modal={this.state.createModal}
            modalBody={
              <CreateBus
                getBuses={this.getBuses}
                handleCreateModal={this.handleCreateModal}
                selectedData={this.state.selectedData}
                edit={this.state.edit}
                page={current_page}
                paginated_value={paginated_value}
              />
            }
            modalHeader={this.state.edit ? "Edit Bus" : "Add Bus"}
            size="xl"
            toggleModal={this.handleCreateModal}
          ></CustomModal>

          <CustomModal
            modal={this.state.imageModal}
            modalBody={
              <BusImagesModal mediaData={this.state.mediaData}></BusImagesModal>
            }
            size="md"
            modalHeader="Bus Images"
            toggleModal={() => this.handleImageModal([])}
          />
          <CustomModal
            modal={this.state.createSeatModal}
            modalClass="busConfigure"
            modalBody={
              <CreateBusSeatConfiguration
                edit={this.state.edit}
                busId={this.state.busId}
                getBuses={this.getBuses}
                handleCreateSeat={this.handleCreateSeat}
                busTypes={this.state.busTypes}
                selectedData={this.state.selectedData}
                seatConfigData={this.state.seatConfigData}
              />
            }
            modalHeader={
              this.state.edit
                ? "Edit Bus Seat Configuration"
                : "Add Bus Seat Configuration"
            }
            size="xl"
            toggleModal={this.handleCreateSeat}
          ></CustomModal>

          <CustomModal
            modal={this.state.viewModal}
            modalBody={
              <div style={{ zoom: "70%" }}>
                <BusSeatUI
                  seats={this.state.seatConfigData}
                  config={true}
                  view={true}
                />
              </div>
            }
            modalHeader="Bus Seat Configuration"
            toggleModal={this.handleViewSeat}
          />
        </div>
      </>
    );
  }
}

export default Bus;
